import { useLanguage } from "../i18n";
import { UndoIcon } from "../icons";
import { GRACE_MS, useLogger } from "../logger";

/**
 * Carries UNDO. It is not the confirmation — the row changing is.
 *
 * NN/g documents people missing transient messages entirely, so nothing
 * important lives only here.
 */
export function UndoBar() {
  const { t } = useLanguage();
  const { pending, undo } = useLogger();

  if (pending.length === 0) return null;

  const latest = pending[pending.length - 1];

  return (
    <div className="undo-bar" role="status" aria-live="polite">
      <span className="undo-text">
        <span className="undo-what">
          {latest.label}
          {pending.length > 1 && ` (+${pending.length - 1})`}
        </span>
        <span className="undo-note">{t.savedToHistory}</span>
      </span>
      <button type="button" className="undo-action" onClick={() => undo(latest.key)}>
        <UndoIcon />
        {t.undo}
      </button>
      {/*
        The window draining, so he can see how long he has rather than guess.
        Keyed on the record so a new one restarts the drain.
      */}
      <span
        key={latest.key}
        className="undo-drain"
        style={{ animationDuration: `${GRACE_MS}ms` }}
        aria-hidden="true"
      />
    </div>
  );
}
